import { z } from 'zod';

// ── Company Response ──

export const CompanyResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string().nullable(),
  domain: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  industry: z.string().nullable(),
  employee_count: z.number().int().nullable(),
  employee_range: z.string().nullable(),
  follower_count: z.number().int().nullable(),
  hq_city: z.string().nullable(),
  hq_country: z.string().nullable(),
  hq_continent: z.string().nullable(),
  hq_region: z.string().nullable(),
  hq_full_address: z.string().nullable(),
  hq_postal_code: z.string().nullable(),
  logo_url: z.string().nullable(),
  linkedin_url: z.string().nullable(),
  linkedin_id: z.string().nullable(),
  website: z.string().nullable(),
  year_founded: z.number().int().nullable(),
  specialties: z.string().nullable(),
  tagline: z.string().nullable(),
  company_type: z.string().nullable(),
  locations: z.any().nullable(),
  licence_id: z.uuid().nullable(),
  list_id: z.uuid().nullable(),
  data_updated_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type CompanyResponse = z.infer<typeof CompanyResponseSchema>;

// ── Wrappers ──

export const CompanyListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(CompanyResponseSchema),
});
export type CompanyListResponse = z.infer<typeof CompanyListResponseSchema>;
